import styled from 'styled-components';
import { textStyles } from "../Text/Text";
import { theme } from "../../theme";
export var TextFieldLabel = styled.label.withConfig({
  displayName: "TextFieldLabel",
  componentId: "vapor__led8s9-0"
})(["", ";color:", ";"], textStyles.body, theme.colors.palette.grey60);